<template>
  <v-card color="kbWhite">
    <v-card-title class="text-h6">
      <v-row>
        <v-col cols="12" class="d-flex justify-space-between mx-2">
          <h4 class="font-weight-medium kbDarkBlueText--text">Micro Site</h4>
          <v-spacer></v-spacer>
          <v-btn v-if="slug"
            @mouseover="displayCopyKeyBtn = true"
            @mouseleave="displayCopyKeyBtn = false"
            @click="copyUrl"
            color="kbPurple"
            dark
            class="d-inline-block mr-3" style="text-transform: none !important;"
          >
            <span class="px-2">{{ microSiteUrl }}</span>
            <transition name="fade">
              <v-btn icon
                     dark
                     v-if="displayCopyKeyBtn">
                <v-icon>file_copy</v-icon>
              </v-btn>
            </transition>
          </v-btn>
        </v-col>
      </v-row>
      <span class="pt-2 kbDarkBlueText--text"></span>
    </v-card-title>

    <v-card-text>
      <v-form v-model="valid" ref="emailVerifyRef" lazy-validation>
        <v-row>
          <v-col cols="12">
            <v-text-field prepend-icon="mdi-form-textbox"
                          label="Slug"
                          color="kbDarkBlueText"
                          @keypress="onSlugChange"
                          v-model="slug" >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field prepend-icon="mdi-domain"
                          label="Name"
                          color="kbDarkBlueText"
                          v-model="name" >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea prepend-icon="mdi-image-text"
                          label="Bio"
                          color="kbDarkBlueText"
                          v-model="bio" >
            </v-textarea>
          </v-col>
          <v-col cols="12">
            <v-text-field prepend-icon="mdi-instagram"
                          label="Instagram Link"
                          color="kbDarkBlueText"
                          v-model="instagram" >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field prepend-icon="mdi-facebook"
                          label="Facebook Link"
                          color="kbDarkBlueText"
                          v-model="facebook" >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field prepend-icon="mdi-mail"
                          label="Email"
                          color="kbDarkBlueText"
                          v-model="email" >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field prepend-icon="mdi-whatsapp"
                          label="Whatsapp Link"
                          color="kbDarkBlueText"
                          v-model="whatsapp" >
            </v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="kbLightBlue"
        dark :loading="updatingApp"
        @click="submit()">{{$t('general.update')}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  created () {
    const extradata = this.selectedApp.extra_data
    const slug = this.selectedApp.slug
    const name = extradata.find(extradata => { return extradata.field === 'microsites_name' })
    const bio = extradata.find(extradata => { return extradata.field === 'microsites_bio' })
    const instagram = extradata.find(extradata => { return extradata.field === 'microsites_link_instagram' })
    const facebook = extradata.find(extradata => { return extradata.field === 'microsites_link_facebook' })
    const email = extradata.find(extradata => { return extradata.field === 'microsites_link_email' })
    const whatsapp = extradata.find(extradata => { return extradata.field === 'microsites_link_whatsapp' })

    if (slug) this.slug = slug
    if (name) this.name = name.value
    if (bio) this.bio = bio.value
    if (instagram) this.instagram = instagram.value
    if (facebook) this.facebook = facebook.value
    if (email) this.email = email.value
    if (whatsapp) this.whatsapp = whatsapp.value
  },
  data () {
    return {
      slug: '',
      name: '',
      bio: '',
      instagram: '',
      facebook: '',
      email: '',
      whatsapp: '',
      customLink: '',
      rules,
      valid: false,
      displayCopyKeyBtn: false,
      updatingApp: false
    }
  },
  computed: {
    ...mapState({
      selectedApp: state => state.apps.selectedApp
    }),
    microSiteUrl () {
      return `https://${this.slug}.kbe.ai`
    }
  },
  methods: {
    submit () {
      const extradata = [
        { access: 'public', field: 'microsites_slug', value: this.slug },
        { access: 'public', field: 'microsites_name', value: this.name },
        { access: 'public', field: 'microsites_bio', value: this.bio },
        { access: 'public', field: 'microsites_link_instagram', value: this.instagram },
        { access: 'public', field: 'microsites_link_facebook', value: this.facebook },
        { access: 'public', field: 'microsites_link_email', value: this.email },
        { access: 'public', field: 'microsites_link_whatsapp', value: this.whatsapp }
      ]
      const companyId = this.$store.getters.companyUuid
      const appId = this.$store.getters.appUuid
      const data = { slug: this.slug, extradata: extradata }
      this.updatingApp = true
      const successMsg = this.$t('general.applicationSuccessfullyUpdated')
      this.$store.dispatch('updateApp', { companyId, appId, data }).then(() => {
        this.updatingApp = false
        notifications.success(successMsg)
      }).catch(error => {
        this.updatingApp = false
        notifications.error(error.message)
      })
    },
    copyUrl () {
      navigator.clipboard.writeText(this.microSiteUrl).then(() => {
        notifications.success(this.$t('general.apiKeyCopied'))
      }).catch(() => {
        notifications.error(this.$t('general.apiKeyCopyError'))
      })
    },
    onSlugChange (event) {
      this.slug = this.slug.toString().toLowerCase().replace(' ', '-')
    }
  }
}
</script>
